import { ReadonlyURLSearchParams } from 'next/navigation';

type Variables = {
  id: string;
  searchParams: ReadonlyURLSearchParams | URLSearchParams;
  name: string;
};
export default function getDistincFacetsAsQueryString(args: Variables) {
  const { name, searchParams, id } = args;

  const newSearchParams = new URLSearchParams(searchParams.toString());
  const currentName = searchParams.get(id.toLowerCase());

  if (typeof currentName !== 'string') {
    newSearchParams.set(id.toLowerCase(), name);
    return newSearchParams.toString();
  }

  let distinctValues: string = '';
  const allValues = currentName.split(',');

  if (allValues.includes(name)) {
    distinctValues = allValues.filter((v) => v !== name).join(',');
  } else {
    distinctValues = `${name},${currentName}`;
  }

  if (distinctValues === '') {
    newSearchParams.delete(id.toLowerCase());
  } else {
    newSearchParams.set(id.toLowerCase(), distinctValues);
  }
  return newSearchParams.toString();
}
